export const MERGE_ALERTS_TO_CASE = 'MERGE_ALERTS_TO_CASE';
export const MERGE_ALERTS_TO_CASE_SUCCESS = 'MERGE_ALERTS_TO_CASE_SUCCESS';
export const MERGE_ALERTS_TO_CASE_FAIL = 'MERGE_ALERTS_TO_CASE_FAIL';
export const CLOSE_MERGE_ALERTS_TO_CASE_MODAL =
  'CLOSE_MERGE_ALERTS_TO_CASE_MODAL';

export const mergeAlertsToCase = (alertIds, caseId) => ({
  type: MERGE_ALERTS_TO_CASE,
  payload: { alertIds, caseId }
});

export const mergeAlertsToCaseSuccess = ({ assignedDepartmentId }) => ({
  type: MERGE_ALERTS_TO_CASE_SUCCESS,
  payload: { assignedDepartmentId }
});

export const mergeAlertsToCaseFail = ({ message }) => ({
  type: MERGE_ALERTS_TO_CASE_FAIL,
  payload: { message }
});

export const closeMergeFromAlertInfoModal = () => ({
  type: CLOSE_MERGE_ALERTS_TO_CASE_MODAL
});
